export {MockDealCardService} from './mock-deal-card/mock-deal-card.service';
